let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("65d3q")]).then(() => parcelRequire('15BcA'));